import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {NextVisitReminderSettingsService} from "../../providers/next-visit-reminder-settings.service";
import {NextVisitReminderSettings} from "../../models/next-visit-reminder-settings.model";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {VetClinic} from "../../models/vet-clinic.model";
import {switchMap} from "rxjs/operators";

@Component({
  selector: 'app-edit-next-visit-reminder-settings',
  templateUrl: './edit-next-visit-reminder-settings.component.html',
  styleUrls: ['./edit-next-visit-reminder-settings.component.scss'],
})
export class EditNextVisitReminderSettingsComponent implements OnInit, OnDestroy {

  isBusy: boolean;
  @Input()
  vetClinic: VetClinic;
  @Input()
  vetcodeId: number;

  nextVisitReminderSettings: NextVisitReminderSettings;
  nextVisitReminderFormalSettings: NextVisitReminderSettings;
  isAddMode: boolean = true;
  reminderSettingsForm: FormGroup;
  buttonActionTxt: string = 'Zapisz zmiany';
  sendSecondReminder: boolean = false;
  fetchNextVisitReminderSettingsSubscription: Subscription;
  dataPreparedToShowForm: boolean = false;

  @Output()
  nextVisitReminderSettingsEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();

  @Output()
  cancelVisitReminderSettingsEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  defaultSettingsSub: Subscription;
  addSub: Subscription;
  editSub: Subscription;
  private delayDayChange: boolean = false;
  private hasUnsavedChanges: boolean = false;
  type: 'FORMAL' | 'INFORMAL' = 'INFORMAL';
  daysToMakeReservationTermAvailableForReminders: string = '21';

  constructor(private nextVisitReminderSettingsService: NextVisitReminderSettingsService, private appStateService: AppStateService,
              private commonUtils: CommonUtils, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.fetchSettings();
    if(this.vetClinic.daysToMakeReservationTermAvailableForReminders) {
      this.daysToMakeReservationTermAvailableForReminders = this.vetClinic.daysToMakeReservationTermAvailableForReminders.toString();
    }
    this.appStateService.updateIsBusySubject(false);
  }

  onCancelAction() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz anulować zapisywanie ustawień przypomnień?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.cancelVisitReminderSettingsEmitter.emit(true);
    }, () => {
    });
  }

  private editNextVisitReminderSettings() {
    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
      this.appStateService.updateIsBusySubject(true);

      this.addSub = this.nextVisitReminderSettingsService.changeNextVisitReminderSettings(this.vetClinic.uuid, this.type, Number.parseInt(this.daysToMakeReservationTermAvailableForReminders))
        .subscribe((vetClinic: VetClinic) => {
          console.log(vetClinic)
          if (vetClinic) {
            this.commonUtils.presentInfoToast("Zmiany w powiadomieniach zostały zapisane").then(res => {
              this.nextVisitReminderSettingsEmitter.emit(vetClinic);
              this.appStateService.updateIsBusySubject(false);
            });
          } else {
            this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany ustawień powiadomień");
            this.appStateService.updateIsBusySubject(false);
          }

        }, error => {
          this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany ustawień powiadomień");
          this.appStateService.updateIsBusySubject(false);
        });

    }, () => {
    });
  }

  ngOnDestroy(): void {
    if (this.fetchNextVisitReminderSettingsSubscription) this.fetchNextVisitReminderSettingsSubscription.unsubscribe();
    if (this.defaultSettingsSub) this.defaultSettingsSub.unsubscribe();
    if (this.addSub) this.addSub.unsubscribe();
    if (this.editSub) this.editSub.unsubscribe();
  }

  isFormFieldInvalid(form: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(form, fieldName, validationType);
  }

  handleForm(type) {
    this.dataPreparedToShowForm = true;
    let settings = this.nextVisitReminderSettings;

    if(!type){
      if(this.vetClinic.nextVisitReminderType && this.vetClinic.nextVisitReminderType == 'FORMAL'){
        this.type = 'FORMAL';
      }
    } else {
      this.type = type;
    }

    if (this.type === 'FORMAL') {
      if (this.nextVisitReminderFormalSettings) {
        settings = this.nextVisitReminderFormalSettings;
      } else {
        this.commonUtils.presentAlertToast('Nie można pobrać ustawień dla komunikatów formalnych, spróbuj później')
      }
    }

    this.reminderSettingsForm = this.formBuilder.group({
      firstReminderEmailText: [settings?.firstReminderEmailText, Validators.required],
      firstReminderEmailTitle: [settings?.firstReminderEmailTitle, Validators.required],
      firstReminderPushText: [settings?.firstReminderPushText, Validators.required],
      firstReminderPushTitle: [settings?.firstReminderPushTitle, Validators.required],
      firstReminderDaysDelay: [settings?.firstReminderDaysDelay, Validators.required],
      visitTypeEmailText: [settings?.visitTypeEmailText, Validators.required],
      visitTypeEmailTitle: [settings?.visitTypeEmailTitle, Validators.required],
      visitTypePushText: [settings?.visitTypePushText, Validators.required],
      visitTypePushTitle: [settings?.visitTypePushTitle, Validators.required],
      flashReminderEmailTitle: [settings?.flashReminderEmailTitle, Validators.required],
      flashReminderEmailText: [settings?.flashReminderEmailText, Validators.required],
      flashReminderPushText: [settings?.flashReminderPushText, Validators.required],
      flashReminderPushTitle: [settings?.flashReminderPushTitle, Validators.required],
      visitTypeDaysDelay: [settings?.visitTypeDaysDelay, Validators.required]
    });
  }

  fetchSettings() {
    this.appStateService.updateIsBusySubject(true);
    this.defaultSettingsSub = this.nextVisitReminderSettingsService.getFormalDefaultSettings().pipe(switchMap(formalSettings => {
      if (formalSettings) {
        this.nextVisitReminderFormalSettings = formalSettings;
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobierania ustawień')
      }
      return this.nextVisitReminderSettingsService.getDefaultSettings();
    })).subscribe(settings => {
      if (settings) {
        this.nextVisitReminderSettings = settings;
        this.handleForm(null);
      } else {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobierania ustawień')
      }
      this.appStateService.updateIsBusySubject(false);

    },error => {
      this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobierania ustawień');
      this.appStateService.updateIsBusySubject(true);
    });
  }


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEmitter.emit(true);

    }
  }

  handleChangeDaysToMakeReservationTermAvailableForReminder(daysToMakeReservationTermAvailableForReminders: any) {
    this.daysToMakeReservationTermAvailableForReminders = daysToMakeReservationTermAvailableForReminders;
  }
}
